import { queryParams } from "libs/api/interceptors";

type RequestConfig = {
  version?: string;
  endpoint: string;
  method: "GET" | "POST" | "PATCH" | "DELETE";
  body?: unknown;
  interceptors?: unknown[];
};

type ApiClient = {
  request: (_requestConfig: RequestConfig) => Promise<unknown>;
};

type CartsConfig = {
  widgetUUID: string;
};

export default function carts(client: ApiClient, config: CartsConfig) {
  const path = `/widgets/${config.widgetUUID}/carts`;
  return {
    create: (data: unknown) => client.request({
      version: "v2",
      endpoint: `${path}`,
      method: "POST",
      body: data,
    }),
    delete: (id: string) => client.request({
      version: "v2",
      endpoint: `${path}/${id}`,
      method: "DELETE",
    }),
    get: (id: string, options?: { includeProjectedBalances?: boolean }) => {
      const params = options?.includeProjectedBalances ? "?include_projected_balances=true" : "";
      return client.request({
        version: "v2",
        endpoint: `${path}/${id}${params}`,
        method: "GET",
      });
    },
    getWithPaymentReference: (id: string, paymentReference: string) => client.request({
      version: "v2",
      endpoint: `${path}/${id}?payment_reference=${paymentReference}`,
      method: "GET",
    }),
    list: (queryParamsInput: Record<string, string>) => client.request({
      version: "v2",
      endpoint: `${path}?ordering=-id`,
      method: "GET",
      interceptors: Object.values(queryParamsInput)?.length ? [queryParams(queryParamsInput)] : [],
    }),
    partialUpdate: (uuid: string, data: unknown, options?: { includeProjectedBalances?: boolean }) => {
      const params = options?.includeProjectedBalances ? "?include_projected_balances=true" : "";
      return client.request({
        version: "v2",
        endpoint: `${path}/${uuid}${params}`,
        method: "PATCH",
        body: data,
      });
    },
    pay: (uuid: string, data: unknown) => client.request({
      version: "v2",
      endpoint: `${path}/${uuid}/pay`,
      method: "POST",
      body: data,
    }),
  };
}
